export type Theme = "light" | "dark";

const THEME_KEY = "ich-theme";

export const getTheme = (): Theme => {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    return stored === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyTheme = (theme: Theme) => {
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};

/** Call once on app start to restore the persisted theme. */
export const initTheme = () => {
  applyTheme(getTheme());
};
